import cloneDeep from 'lodash/cloneDeep'
import initialState from './state.js'

export default {
  RESET_HIGHLIGHT_DATA(state) {
    const initial = cloneDeep(initialState)
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
  SET_HIGHLIGHT_KEY_VALUE(state, { payload, key }) {
    state.highlightOffer[key] = payload
  },
  SET_HIGHLIGHT(state, payload) {
    state.highlightOffer = payload
  },
  SET_TAG_TYPE(state, payload) {
    state.tagType = payload
  },
  SET_USE_HEADER_IMAGE(state, payload) {
    state.isUsingHeaderImage = payload
  },
  SET_STATUS(state, payload) {
    state.status = payload
  },
  SET_OFFER_SCHEDULE(state, payload) {
    state.offerSchedule = payload
  },
  SET_HIGHLIGHT_PRODUCTS(state, payload) {
    state.highlightProducts = payload
  },
  SET_HIGHLIGHT_DATES(state, payload) {
    state.highlightDates = payload
  },
}
